<input
  type="checkbox"
  role="switch"
  class="switch"
  [attr.id]="controlId ?? generatedRandomId"
  [checked]="isChecked"
  [disabled]="disabled"
  (change)="toggle()" />
